<template>
  <div :class="{_rejected: isRejected && !isInvited}"
       class="resume-fixed-panel  container">
    <div class="resume-fixed-panel__content  container-inner">
      <div class="resume-fixed-panel__btns">
        <ResumeAcceptBtn :isInvited="isInvited"
                         :isRejected="isRejected"
                         :hasInteraction="hasInteraction"
                         :hasInteractionFromAnotherEmployer="hasInteractionFromAnotherEmployer"
                         :responseData="responseData"
                         @accept="$emit('accept')"/>

        <button v-if="!isRejected || isInvited"
          class="base-btn base-btn--outline-orange"
          type="button"
          @click="$emit('decline')"
        >
          <span class="base-btn__text">{{ $tResumePage("Deny") }}</span>
          <BaseSvg name="ico-close" width="1.1rem" height="1.1rem" />
        </button>
      </div>
      <div class="resume-fixed-panel__actual" v-if="$get(responseData, 'invite_send_date')">
          <div class="resume-fixed-panel__actual-item" v-if="$get(responseData, 'invite_send_date')">
            <span>{{ $tResumePage('Invite sent') }}</span>
            <span class="resume-fixed-panel__actual-item-text">{{ $get(responseData, 'invite_send_date') | formatDate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ResumeAcceptBtn from './ResumeAcceptBtn'

  export default {
    name: 'ResumeFixedPanel',
    components: {
      ResumeAcceptBtn
    },
    props: ['hasInteraction', 'hasInteractionFromAnotherEmployer', 'responseData', 'isInvited', 'isRejected'],
  }
</script>

